<template>
  <div>
    <vx-card v-if="monthDistribuitionInfo" class="mb-4">
      <div>
        <p class="font-bold text-xl">
          Distribuição Mensal - {{ currentMonthName }}
        </p>
      </div>
      <div class="mt-4 mb-4 flex flex-row flex-wrap w-full gap-16">
        <div class="flex items-center">
          <span class="font-bold mr-2">Saldo do Mês:</span>
          <vs-chip color="primary">
            <span class="font-bold">{{
              functions.formataReal(monthDistribuitionInfo.monthAmout)
            }}</span>
          </vs-chip>
        </div>

        <div class="flex items-center">
          <span class="font-bold mr-2">Saldo Distribuído:</span>
          <vs-chip color="success">
            <span class="font-bold">
              {{
                functions.formataReal(monthDistribuitionInfo.distributed)
              }}</span
            >
          </vs-chip>
        </div>
        <div class="flex items-center">
          <span class="font-bold mr-2">Saldo à Distribuir:</span>
          <vs-chip color="warning">
            <span class="font-bold">
              {{
                functions.formataReal(monthDistribuitionInfo.toDistribute)
              }}</span
            >
          </vs-chip>
        </div>
        <div class="flex items-center">
          <span class="font-bold mr-2">Saldo Utilizado:</span>
          <vs-chip color="danger">
            <span class="font-bold">{{
              functions.formataReal(monthDistribuitionInfo.balanceSpent)
            }}</span>
          </vs-chip>
        </div>
      </div>
    </vx-card>

    <vx-card>
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          noDataText="Nenhum Upload Encontrado"
          class="tablePrincipal"
          ref="table"
          multiple
          v-model="selected"
          pagination
          :max-items="itemsPerPage"
          :data="brokerAccountCreditLogs"
        >
          <div slot="header" class="w-full">
            <div
              class="flex flex-wrap-reverse items-center flex-grow justify-between"
            >
              <div class="flex items-center">
                <vs-button
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                  @click="downloadExampleFile"
                  color="primary"
                  type="border"
                  class="h-12 mr-4"
                  data-testid="download-broker-account-file"
                >
                  <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2">Baixar Modelo</span>
                </vs-button>
                <vs-button
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                  @click="handleButtonClick"
                  :color="file ? 'success' : 'primary'"
                  :type="file ? 'filled' : 'border'"
                  class="h-12"
                  data-testid="upload-broker-account-file"
                >
                  <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2">{{ buttonLabel }}</span>
                </vs-button>
                <input
                  type="file"
                  ref="fileInput"
                  @change="handleFileChange"
                  style="display: none"
                />
              </div>
              <PaginationItemsPerPageDropdown
                :items-per-page="itemsPerPage"
                :total-items="brokerAccountCreditLogs.length"
                :current-page="currentPage"
                @update:itemsPerPage="itemsPerPage = $event"
              />
            </div>
          </div>
          <template slot="thead">
            <vs-th>Arquivo Enviado</vs-th>
            <vs-th>Data do Envio</vs-th>
            <vs-th>Usuário</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>Retorno</vs-th>
          </template>
          <template v-slot="{ data }">
            <tbody>
              <vs-tr :data="log" :key="index" v-for="(log, index) in data">
                <vs-td>
                  <p class="product-category">
                    <a
                      :href="log.fileUrl"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <feather-icon icon="Download" svgClasses="h-4 w-4" />
                      {{ extractFileName(log.fileUrl) }}
                    </a>
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ formatDateBr(log.createdAt) }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ log.user.name }}</p>
                </vs-td>
                <vs-td>
                  <vs-chip :color="getStatusColor(log.status)">{{
                    log.status
                  }}</vs-chip>
                </vs-td>
                <vs-td>
                  <p class="product-category" v-if="!isUrl(log.logFileUrl)">
                    {{ log.logFileUrl }}
                  </p>
                  <p class="product-category" v-else>
                    <a
                      :href="log.logFileUrl"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <feather-icon icon="Download" svgClasses="h-4 w-4" />
                      {{ extractFileName(log.logFileUrl) }}
                    </a>
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import moment from 'moment';
import brokerAccountService from '../../../services/broker.account.transaction.api';
import functions from '../../../utils/functions';
import notify from '../../../utils/notify';
import autoApi from '../../../services/auto.api';
import PaginationItemsPerPageDropdown from '../../../components/PaginationItemsPerPageDropdown.vue';

export default {
  name: 'conta-corrente-list',
  components: { PaginationItemsPerPageDropdown },
  props: ['subjectPermission'],
  data() {
    return {
      brokerAccountCreditLogs: [],
      itemsPerPage: 50,
      currentPage: 1,
      selected: [],
      file: null,
      buttonLabel: 'Selecionar Arquivo',
      functions,
      moment,
      statusColor: {
        Criado: 'primary',
        Processando: 'warning',
        Concluído: 'success',
        Falhou: 'danger',
        Sucesso: 'success',
        Erro: 'danger',
      },
      monthDistribuitionInfo: null,
    };
  },

  computed: {
    currentMonthName() {
      return this.capitalizeFirstLetter(moment().format('MMMM'));
    },
  },
  created() {
    moment.locale('pt');
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      await Promise.all([this.getMonthDistribuitionInfo(), this.getLogs()]);
    },
    async getMonthDistribuitionInfo() {
      try {
        this.$vs.loading();
        const data = await autoApi.getMonthDistribuitionInfo();
        this.monthDistribuitionInfo = data;
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Erro ao buscar informações de distribuição mensal.',
        );
      } finally {
        this.$vs.loading.close();
      }
    },
    async getLogs() {
      const response = await brokerAccountService.getLogs();
      this.brokerAccountCreditLogs = response;
    },
    formatDateBr(date) {
      return moment(date).format('DD/MM/YYYY H:mm:ss');
    },
    isUrl(string) {
      try {
        new URL(string);
        return true;
      } catch (error) {
        return false;
      }
    },
    handleButtonClick() {
      if (!this.file) {
        this.$refs.fileInput.click();
      } else {
        this.uploadFile();
      }
    },
    handleFileChange(event) {
      this.file = event.target.files[0];
      if (this.file) {
        this.buttonLabel = 'Enviar Arquivo';
      }
    },
    async uploadFile() {
      if (this.file) {
        try {
          this.$vs.loading();
          await brokerAccountService.uploadFile(this.file);
          this.buttonLabel = 'Selecionar Arquivo';
          this.file = null;
          await this.getLogs();
          notify.notifySuccess(this.$vs, 'Arquivo enviado com sucesso.');
        } catch (error) {
          notify.notifyFail(this.$vs, 'Não foi possível enviar o arquivo.');
          console.error('Erro ao enviar arquivo', error);
        } finally {
          this.$vs.loading.close();
        }
      } else {
        console.error('Nenhum arquivo selecionado');
      }
    },
    async downloadExampleFile() {
      try {
        this.$vs.loading();
        const response = await brokerAccountService.downloadFile();
        const blob = new Blob([response], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'current-account-corretoras.csv';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.$vs.loading.close();
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao fazer download do arquivo.');
        console.error('Erro ao fazer download do arquivo', error);
        this.$vs.loading.close();
      }
    },
    getStatusColor(status) {
      return this.statusColor[status];
    },
    extractFileName(url) {
      if (!url || !url.includes('Z-')) return url;
      return url.split('Z-')[1];
    },
    capitalizeFirstLetter(text) {
      if (!text) return '';
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}
</style>
